<template>
  <div> <b-button :size="size" :class="bgcolor" style="border-color:white;" @click="addNew">
      <Icon style="margin-right: 5px" :icon="icon" width="20" height="20" v-b-tooltip.hover.bottom="$t(title)" />
      {{ $t(title) }}
    </b-button>
  </div>
</template>
<script>
import { Icon } from "@iconify/vue2";
export default {
  props: { 'bgcolor': { type: String }, 'title': { type: String }, 'icon': { type: String }, 'size': { type: String } },
  components: { Icon },
  methods: { addNew() { this.$root.$emit("addNewData"); } },
}
</script>